import { AUTH_API_BASE_URL, urlFor, request } from '../index';

export async function getAccountingRepositDeposit(params) {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/accounting-report/deposit?${params}`), {
      auth: true
    });
  } catch (e) {
    return e
  }
}

export async function getAccountingRepositWithdraw(params) {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/accounting-report/withdraw?${params}`), {
      auth: true
    });
  } catch (e) {
    return e
  }
}

export async function getAccountingFirstDeposit(params) {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/accounting-report/firstdeposit?time_from=${params.time_from}&time_to=${params.time_to}&page=${params.page}&rows=${params.rows}`), {
      auth: true
    });
  } catch (e) {
    return e
  }
}

export async function getAccountingNoDeposit(params) {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/accounting-report/nodeposit?type=${params.type}&page=${params.page}&rows=${params.rows}`), {
      auth: true
    });
  } catch (e) {
    return e
  }
}

export async function getAccountingDepositPromotion(params) {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/accounting-report/deposit-promotion?promotion_id=${params.promotion_id}&page=${params.page}&rows=${params.rows}&time_from=${params.time_from}&time_to=${params.time_to}`), {
      auth: true
    });
  } catch (e) {
    return e
  }
}
